<template>
  <v-container fluid>
    <div v-if="authenticated">
      <v-layout align-start wrap justify-start>
        <v-flex xs12>
          <span class="dHeading">Re:Firings</span>
          <v-expansion-panel popout>
              <v-expansion-panel-content>
                  <div slot="header">Current Firings</div>
                  <current-firings></current-firings>
              </v-expansion-panel-content>
              <v-expansion-panel-content>
                  <div slot="header">View Firings</div>
                  <view-firings></view-firings>
              </v-expansion-panel-content>
              <v-expansion-panel-content>
                  <div slot="header">Start a Firing</div>
                  <config-firings></config-firings>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import CurrentFirings from './FiringsCurrentComponent'
import ViewFirings from './FiringsViewComponent'
import ConfigFirings from './FiringsConfigComponent'

  export default {
      data() {
          return {}
      },
    components: {
        CurrentFirings,
        ViewFirings,
        ConfigFirings
    },
    computed: {
        ...mapState([
            'authenticated'
        ])
    }
  }
</script>

<style scoped>
.dHeading {
    font-size: 20px;
    font-weight: bold
}
</style>